import type { ComponentRegistry } from "@json-render/react";

import { ReportImageFromProps } from "@/components/ui/report/ReportBannerImage/ReportBannerImageSpec";
import { heraldRendererRegistry } from "@/lib/chat/heraldRendererRegistry";
import { reportRendererRegistry } from "@/lib/template-studio/reportRendererRegistry";

/** Herald chat types omitted from Template Studio catalog and preview. */
export const TEMPLATE_STUDIO_EXCLUDED_HERALD_COMPONENTS = [
  "Callout",
  "Quote",
  "Button",
  "SuggestionChips",
  "SparkChartRow",
  "Timeline",
  "Skeleton",
  "Radio",
  "Select",
] as const;

const excludedHeraldComponents = new Set<string>(
  TEMPLATE_STUDIO_EXCLUDED_HERALD_COMPONENTS,
);

const heraldComponentsForTemplateStudio = Object.fromEntries(
  Object.entries(heraldRendererRegistry).filter(
    ([componentType]) => !excludedHeraldComponents.has(componentType),
  ),
) as ComponentRegistry;

/** Herald chat registry plus Template Studio report chrome components. */
export const templateStudioRendererRegistry: ComponentRegistry = {
  ...heraldComponentsForTemplateStudio,
  ...reportRendererRegistry,
  Image: ReportImageFromProps,
};

/** @public Sorted Template Studio component types (registry keys). */
export const templateStudioRendererComponentTypes = Object.keys(
  templateStudioRendererRegistry,
).sort();
